import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Devicescruds from '../../modules/ctr-r/CTXRegister/Devices';
import { useAppSelector } from '../../../redux/hooks';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para la carga

const Register: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // Estado para gestionar la carga

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener la carga cuando los permisos estén cargados
        if (!ListaPermisosTenant.includes('CTXR.List')) {
          // Si no tiene permisos para CTXR.List, validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo

    // Limpiar timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar spinner mientras se cargan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/*" element={<Devicescruds />} />
      </Routes>
    </>
  );
}

export { Register };
